import produce from 'immer'
import config from './_config'
import { Contacts } from './types'
import { useMutation } from '../../internal'

const useCreateContact = () => {
  const mutation = useMutation()

  return mutation<Contacts.Contact[], Contacts.Create>({
    method: 'POST',
    endpoint: config?.endpoint,
    cacheKey: config.cacheKeys.list(),
    cacheUpdateMode: 'settled',
    cacheUpdater: (snapshot, newContact) => {
      return produce(snapshot, (draft = []) => {
        return [...draft, newContact]
      })
    }
  })
}

export default useCreateContact
